import * as types from 'constants/ActionTypes';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/** @type {boolean} */
const initialState = false;

const isReady = () => true;

const isNotReady = () => false;

export default createReducer(initialState, {
  [LOCATION_CHANGE]: isNotReady,
  [types.STATISTICS_DEALER_DETAILS_READY]: isReady,
});
